module.exports = __webpack_public_path__ + "static/media/ashpbg.be1cada8.png";